import { useEffect } from 'react';
import { useErrorPage } from '@/hooks/useErrorPage';
import { extractStatusCodeFromApolloResponse } from '@/utils';
import { useGetStructureNameQuery } from '@/__generated__/graphql';
import { DeploymentBanner } from '@/components/shared/DeploymentBanner';

type StructureCheckProps = {
  structureId: string;
  children: React.ReactNode;
};

export const StructureCheck = ({ structureId, children }: StructureCheckProps) => {
  const structureQueryResult = useGetStructureNameQuery({
    variables: {
      structureId,
    },
    fetchPolicy: 'cache-first',
  });

  const errorStatusCode = extractStatusCodeFromApolloResponse(
    structureQueryResult.error?.graphQLErrors[0]?.extensions?.originalError
  );

  const redirectToErrorPage = useErrorPage(errorStatusCode);

  useEffect(() => {
    if (errorStatusCode && redirectToErrorPage) {
      redirectToErrorPage();
    }
  }, [errorStatusCode, redirectToErrorPage, structureQueryResult?.error?.graphQLErrors]);

  return (
    <>
      <DeploymentBanner structureId={structureId} />
      {children}
    </>
  );
};
